import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import { AddPropanePromotionForm } from "../../../../components/parts/forms";
import { POST_API_URLS } from "../../../../utils/constant";
import styles from "./style.module.scss";
import { CardWrapper } from "../../../../components/wrapper";
import { FormErrorPopup } from "../../../../components/parts/popups";

const AddPropanePromotion = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const addPropanePromotionHandler = (data) => {
    setLoading(true);
    let formData = new FormData();
    
    // Transform data to match new API structure
    for (let k in data) {
      formData.append(k, data[k]);
    }

    console.log("Submitting new promotion data:", data);

    jwtInterceoptor
      .post(POST_API_URLS.ADD_PROPANE_PROMOTION, formData)
      .then((response) => {
        console.log(response.data);
        navigate("/dashboard/propane-promotions");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 400) {
          setError(error.response.data.detail);
        } else {
          setError(error.message);
        }
        console.log("Error", error);
      });
  };

  const updatePropanePromotionHandler = (data) => {
    console.log("Updating promotion data:", data);
    setLoading(true);
    let formData = new FormData();
    
    // Transform data to match new API structure
    for (let k in data) {
      formData.append(k, data[k]);
    }

    console.log("Submitting update data:", formData);

    jwtInterceoptor
      .patch(POST_API_URLS.ADD_PROPANE_PROMOTION + `${data.id}/`, formData)
      .then((response) => {
        console.log("Promotion updated successfully:", response.data);
        navigate("/dashboard/propane-promotions");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 403) {
          setError("You dont have permission to edit propane promotions.");
        } else {
          setError(error.message);
        }
        console.log("Error", error);
      });
  };

  return (
    <>
      <div className={styles.addPropanePromotionContainer}>
        <CardWrapper>
          <AddPropanePromotionForm
            updateData={updatePropanePromotionHandler}
            data={addPropanePromotionHandler}
            loading={loading}
            formInitialValues={location.state || null}
          />
        </CardWrapper>
      </div>
      {error && <FormErrorPopup error={error} close={() => setError(false)} />}
    </>
  );
};

export default AddPropanePromotion;
